import { render, staticRenderFns } from "./FieldDialog.vue?vue&type=template&id=18445dfe&scoped=true&"
import script from "./FieldDialog.vue?vue&type=script&lang=js&"
export * from "./FieldDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18445dfe",
  null
  
)

export default component.exports